module.exports = __webpack_public_path__ + "img/SAPICAFC.b36ec72e.png";